/* eslint-disable */
import { Box, Select } from '@chakra-ui/react';
import React from 'react';
import Card from 'components/Cards/Card';
import FilterSearchBar from '../User/components/FilterSearchBar';
// import CustomPaginationTable from 'components/Table/CustomPaginationTable';
import { getTransactionTableHeader } from 'components/Table/Headers/Company/companyTableHeader';
import { useSearchParamsHook } from 'hooks/index';
import CustomTable from 'components/Table/CustomTable';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import scores  from 'constants/Select-constants/creditscores.json';

// API IMPORTS
import { useGetAllTransactionQuery } from 'reducers/transaction.service';
import { TRANSATION_TYPES } from 'constants/Select-constants';

const TransactionHome = () => {
    const [searchparams , setSearchParams] = useSearchParamsHook();
    const location = useLocation();
    const ByType = searchparams.get('type') || '';
    const ByStatus = searchparams.get('status') || '';
    const ByScore = searchparams.get('score') || '';
    
    // Use the raw search string for the API query
    const { data, isLoading, isFetching, isError, refetch } = useGetAllTransactionQuery({ query: decodeURIComponent(location.search) }, {
        skip: false,
        refetchOnMountOrArgChange: true
    });

    const handlePageChange = (query)=>{
        return getApprovals(query).unwrap();
    };

    const handleQueryChange = (e) =>{
        let { name, value } = e.target;
        setSearchParams(name, value);
    }

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <Card>
                <FilterSearchBar
                    onRefresh={refetch}
                    isApprovalFilter={false}
                    isProfileFilter={false}
                    isDateFilter={false}
                    isStatus={false}
                    downloadType={'TRANSACTIONS'}
                    isPercentage={false}
                    isApprovalStatusFilter = {false}
                >
                    <Select
                        placeholder="Score"
                        fontWeight="semibold"
                        size="sm"
                        w="150px"
                        name='score'
                        onChange={handleQueryChange}
                        value={ByScore}
                    >
                        {
                            scores.map((row, index)=>(
                                row.value  && <option value={row.value} key={index}>{row.value}</option>
                            ))
                        }
                    </Select>
                    <Select
                        placeholder="Mortgage Type"
                        fontWeight="semibold"
                        size="sm"
                        w="150px"
                        name='type'
                        onChange={handleQueryChange}
                        value={ByType}
                    >
                        {
                            TRANSATION_TYPES.map((row, index)=> row.value && (
                                <option value={row.value} key={index}>{row.label}</option>
                            ))
                        }
                    </Select>
                    <Select
                        placeholder="Status"
                        fontWeight="semibold"
                        size="sm"
                        w="150px"
                        name='status'
                        onChange={handleQueryChange}
                        value={ByStatus}
                    >
                        <option value="CREATED">Created</option>
                        <option value="INPROGRESS">In Progress</option>
                        <option value="BIDDING">Bidding</option>
                        <option value="FUNDED">Funded</option>
                    </Select>

                </FilterSearchBar>

                <div className="page-main-box">
                     <CustomTable
                        showFilters={false}
                        columns={getTransactionTableHeader()}
                        isLoading={isLoading || isFetching }
                        isError={isError}
                        data={data}
                        handleRefresh={refetch}
                        rowStyle={{ cursor: 'pointer', fontSize: '15px' }}
                    />
                </div>
            </Card>
        </Box>
    );
};

export default TransactionHome;
